import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from './auth/session';
import { ToastProvider } from './ui/kit';
import { ApiError } from './api/client';
import { App } from './App';
import { installScheme } from './lib/schemes';
import { installTheme } from './lib/theme';
import './styles.css';
import './app.css';

installTheme();
installScheme();
const queryClient = new QueryClient({
  defaultOptions: {
    // Client errors (validation, not found, forbidden) will not change on a retry.
    queries: { retry: (count, error) => count < 2 && !(error instanceof ApiError && error.status < 500), refetchOnWindowFocus: false, staleTime: 15_000 },
  },
});

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
);
